import { render, staticRenderFns } from "./shipment-detail-graph.vue?vue&type=template&id=0ca8193d&scoped=true&"
import script from "./shipment-detail-graph.vue?vue&type=script&lang=js&"
export * from "./shipment-detail-graph.vue?vue&type=script&lang=js&"
import style0 from "./shipment-detail-graph.vue?vue&type=style&index=0&id=0ca8193d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8193d",
  null
  
)

export default component.exports